import { render, staticRenderFns } from "./MessageSendModal.vue?vue&type=template&id=859ce69a"
import script from "./MessageSendModal.vue?vue&type=script&lang=js"
export * from "./MessageSendModal.vue?vue&type=script&lang=js"
import style0 from "./MessageSendModal.vue?vue&type=style&index=0&id=859ce69a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports